<div class="tab-component">
  <div class="tab-component-wrapper">
    <div class="tab-title peripherals-heading-row">
      <h3>Peripherals</h3>
      <span class="peripherals-info-wrap" [matTooltip]="peripheralInfoTooltip" matTooltipPosition="right"
        [matTooltipShowDelay]="200">
        <button class="peripherals-info-icon" type="button" aria-label="Peripheral information source notice"
          aria-describedby="peripherals-info-tooltip-desc">
          <mat-icon aria-hidden="true">info_outline</mat-icon>
        </button>
      </span>
      <span id="peripherals-info-tooltip-desc" class="visually-hidden">{{ peripheralInfoTooltip }}</span>
    </div>

    <div class="tab-content">
      <div class="tab-content-wrapper content-wrapper-aggrid">
        <div class="component-ag-grid-wrapper" (contextmenu)="preventDefaultContextMenu($event)" mcAgGridCopyCellTooltip
          style="position: relative;">
          <ag-grid-angular style="width: 100%;" class="ag-theme-alpine" [rowModelType]="'infinite'"
            [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"
            (cellContextMenu)="onCellContextMenu($event)">
          </ag-grid-angular>
          <div class="custom-context-menu" *ngIf="contextMenu.visible"
            [ngStyle]="{'top.px': contextMenu.y, 'left.px': contextMenu.x}">
            <ul>
              <li (click)="copyToClipboard(contextMenu.value)">Copy Value</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>